'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  INDIVIDUAL: 'Individual',
  INSTITUTION: 'Family Offices, Corporation, Partnership, Government Entities, Employee Benefit Plan, Irrevocable Trust, etc.',
  OTHER_ENTITIES: 'Bank, Broker-Dealer, Savings and Loan Association, Insurance Company, etc.',
  NONE_OF_THE_ABOVE: 'None Of The Above Applies'
});